import React from "react";
import { useState,useEffect } from "react";
import SalespersonSidebar from "./SalespersonSidebar";
import './classes/ViewTab.css';
import './classes/AddSortflag.css';
import { useParams } from 'react-router-dom';
import { Link, useNavigate,useLocation  } from 'react-router-dom';
import { configData } from "../config";
import Loading from './Loading';
import { Helmet } from 'react-helmet';

const AddSortflag = () =>{
    const [isLoading, setIsLoading] = useState(true);

 
    const [toggle, setToggle] = useState();
    const [errors, setErrors] = useState('');
  const[success,setSuccess] = useState('');
      const location  = useLocation();
      const drupal_uid = localStorage.getItem('drupal_uid');
      const drupal_domain_url = configData.DRUPAL_DOMAIN_URL;
       var loggedin_domain = drupal_domain_url;
      if(localStorage.getItem('loggedin_domain')) {
        loggedin_domain = localStorage.getItem('loggedin_domain');
      } 
      var {uid} = useParams();
      var {username} = useParams();
      if(location.state) {
        uid = location.state;
      }
     
      const {tab} = useParams();
      
      const loggedin_uid = localStorage.getItem('uid');
      const navigate = useNavigate();

        const app_url = configData.APP_URL;
      
        const domain_url = configData.DOMAIN_URL;

    function updateToggle(id){
        setToggle(id);
    
        if(id == 1) { 
           navigate( "/sortflags");
        }
       
     
    }
const [isVisible, setIsVisible] = useState(true);

    const handleClick = () => {
        setIsVisible(!isVisible);
    };
      useEffect(() => {
        setToggle(2);
          if(tab == "list") {
          
            navigate( "/sortflags");
        }
        if(tab == "add") {
          setToggle(2);
        }
     
         } ,[tab]);
         useEffect(() => {
           const timer = setTimeout(() => {
             setIsLoading(false);
           }, 1000); 
         
           return () => clearTimeout(timer); 
         }, []);
  const [formData, setFormData] = useState({
    name: "",
    field_sortflag_archive: false,
    status: true,
  });
  
  const handleChange = (e) => {
    const { name, type, value, checked } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };
  const validateForm = (data) => {
    let errors = "";
    if (!data.name || data.name.trim() === "") {
      errors = "Name is required.";
    }
    return errors;
  };
 const inputStyle = {
  name: {
    border: errors ? '2px solid red' : '1px solid #777'
  },
 };
 const handleSubmit = async (e) => {
  e.preventDefault();
  const validationErrors = validateForm(formData);

  if (validationErrors) {
    setErrors(validationErrors);
    return;
  }
  const response = await fetch(app_url+'sortflag/adminaddsortflag', {
      method: 'POST',
      body: JSON.stringify(formData),
      headers: {
        'Content-Type': 'application/json',
      },
      });
      const data = await response.json();
      if(data.data.msg === "Success") {
        setErrors('');
        setSuccess(data.data.result);
        setFormData({
      name: "",
    field_sortflag_archive: false,
    });
      } else {
        setErrors(data.data.result); 
        setSuccess('');
      }
 
};

    return(
        <>
         {isLoading ? (
              <Loading />
            ) : (
        <div id="main">
          <Helmet><title>Sort Flags | SMWW</title></Helmet>
            <div className="left"></div>
            <div className="center left-center">
                                     {/* {errors.length > 0 && (
          <div className="set-message-error" style={{ background: `#fef5f1 url("/basic/web/images/message-24-error.png") left 10px top 10px no-repeat`}}>
           {errors.map((item, index) => {
           return <>{item}<br /></>
          
        })}  
          </div>
        )} */}
                    {success && (
                        <div className="set-message-done">
                          <span className="cart-message-icon message-icon"><i className="fa fa-check-circle"></i></span> {success}
                        </div>
                        )}
                <>
                      <ul className="tabs primarya">
                        <li className= {toggle === 1? "active" : ""} onClick={()=> updateToggle(1)}><a>List</a></li>
                        {/* {userRoles.includes(configData.ROLE_AGENT) && ( */}
                        <li className= {toggle === 2? "active" : ""} onClick={()=> updateToggle(2)}><a>Add</a></li>
                        {/* )} */}
                      </ul></>
                      
                      {toggle === 2 && (
                    <>
                      <><div className="sortflagadd-container">
                      {/* {Object.keys(errors).length > 0 && (
                        <div className="set-message-error" style={{ background: `#fef5f1 url("/basic/web/images/message-24-error.png") left 10px top 10px no-repeat`, padding: "10px 10px 10px 40px"}}>
                        {Object.keys(errors).map((key, index) => {
                        return <>{errors[key]}<br /></>
                        
                        })}  
                        </div>
                      )} */}
                      {errors &&                         
                      <div className="set-message-error" style={{ background: `#fef5f1 url("/basic/web/images/message-24-error.png") left 10px top 10px no-repeat`, padding: "10px 10px 10px 40px"}}>
                        {errors} 
                      </div>
                      }
                  <form onSubmit={handleSubmit}>
                    <div className="form-item name-field">
                        <label htmlFor="add-name">
                        Name <span className="form-required" title="This field is required.">*</span>
                        </label>
                        <input
                        type="text"
                        id="add-name"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        size="60"
                        maxLength="255"
                        className="form-text required" 
                        style={inputStyle.name}                       
                        />


                    </div>

                    <div className="" id="add-field-sortflag-archive">                    
                        <div className="form-item">
                        <input
                            type="checkbox"
                            id="add-field-sortflag-archive"
                            name="field_sortflag_archive"
                            checked={formData.field_sortflag_archive}
                            onChange={handleChange}
                            className="form-checkbox"
                        />
                        <label className="option" htmlFor="add-field-sortflag-archive">
                            Archive
                        </label>
                        </div>
                     </div>

                    <fieldset style={{border:0,padding:0}}className="" id="add-status">
                      
                        <legend>
                        <span className="publish-option">
                            <span className="fieldset-title" onClick={handleClick} style={{color:"#0074bd", cursor:"pointer"}}>
                                <span style={{ color: "black", fontSize: "8px",marginRight:"2px",marginBottom:"40px" }}>{isVisible ? '▼ ' : '▶ '}</span>
                             Publishing options
                            </span>
                        </span>
                        </legend>
                        {isVisible &&
                      <>
                        <div className="fieldset-wrapper">
                        <div className="form-item">
                            <input
                            type="checkbox"
                            id="edit-status"
                            name="status"
                            checked={formData.status}
                            onChange={handleChange}
                            className="form-checkbox"
                            />
                            <label className="option" htmlFor="edit-status">Published</label>
                            <div className="description">
                            Only privileged users are allowed to view a taxonomy term if this option is disabled
                            </div>
                        </div>
                        </div></>
}
                    </fieldset>

                    <div className="form-actions" id="edit-actions">
                        <button type="submit" className="form-submit" id="edit-submit">
                        Save
                        </button>
                    </div>
                </form>
             </div>
            </>
                    </>
                )}
                
            </div>
            <div className="right">
                <SalespersonSidebar/>
            </div>
        </div>
            )}
            </>
    );
};
export default AddSortflag;